var render = function render(){var _vm=this,_c=_vm._self._c;return _c('homepage',{attrs:{"brand":"liveflight"},on:{"search":_vm.remove_all_filters}})
}
var staticRenderFns = []

export { render, staticRenderFns }